import { EVENT_ID } from '@/constants/event-id';
import { ORDER_STATE_ID } from '@/constants/order-state-id';

export const isOrderClosed = (stateId: number) => stateId !== ORDER_STATE_ID.Pending;

export function getOrderStateEventId(stateId: number): EVENT_ID | null {
    switch (stateId) {
        case ORDER_STATE_ID.Paid:
            return EVENT_ID.OrderPaid;

        case ORDER_STATE_ID.Canceled:
            return EVENT_ID.OrderCancelled;

        case ORDER_STATE_ID.Expired:
            return EVENT_ID.OrderExpired;

        default:
            return null;
    }
}
